export const primaryRetro = {
  50: '#DAE0E7',
  100: '#C9D2DB',
  200: '#A6B4C6',
  300: '#8196AE',
  400: '#5F7997',
  500: '#4D6A8C',
  600: '#46607F',
  700: '#364B63',
  800: '#283547',
  900: '#19222C',
  950: '#0E1216',
};

export const secondaryRetro = {
  50: '#F0D1DF',
  100: '#EABED4',
  200: '#DE94B9',
  300: '#D1699C',
  400: '#C43E80',
  500: '#BF2A72',
  600: '#AC2667',
  700: '#861F51',
  800: '#61173B',
  900: '#3C0F26',
  950: '#1E0A13',
};

export const neutralRetro = {
  50: '#F3EDDF',
  100: '#E0D9C8',
  200: '#D2CEC1',
  300: '#C6C1B4',
  400: '#AFABA0',
  500: '#84817A',
  600: '#6D6B65',
  700: '#4D4D47',
  800: '#3B3A37',
  900: '#282723',
  950: '#11100F',
};

export const errorRetro = {
  50: '#EFD1D3',
  100: '#EAC1C5',
  200: '#DE989F',
  300: '#D16F79',
  400: '#C44653',
  500: '#BE3240',
  600: '#AB2D3A',
  700: '#85242D',
  800: '#601A21',
  900: '#3A1115',
  950: '#1B090A',
};

export const successRetro = {
  50: '#DAE2E0',
  100: '#C6D4D0',
  200: '#A0B7B2',
  300: '#7B9A92',
  400: '#557E74',
  500: '#427065',
  600: '#3C655B',
  700: '#2F4F47',
  800: '#223833',
  900: '#162420',
  950: '#0F1513',
};

export const warningRetro = {
  50: '#EDD7CF',
  100: '#E6C6BA',
  200: '#D7A18C',
  300: '#C87C5F',
  400: '#B95631',
  500: '#B1441B',
  600: '#A03D19',
  700: '#7D3014',
  800: '#59230E',
  900: '#36160A',
  950: '#1D0D07',
};

export const infoRetro = {
  50: '#D5E2EC',
  100: '#BED2E1',
  200: '#94B5CF',
  300: '#6A97BC',
  400: '#3F7BA8',
  500: '#2B6C9F',
  600: '#27628F',
  700: '#1F4C71',
  800: '#163650',
  900: '#0E2231',
  950: '#09131B',
};
